import React from 'react';
import {
	getGridSingleSelectOperators,
	type GridColDef,
	type GridRowParams,
} from '@innovyze/stylovyze';
import { type GroupAction, MenuCell } from './MenuCell';
import { type TFunc } from '@Translations/types';
import { type RehabAction } from '@Types/rehab.types';
import { SkeletonCell } from './SkeletonCell';

export const tableColumns = (
	t: TFunc,
	lengthUnit: string,
	onActionClicked: (action: GroupAction, groupId: string) => void,
	allowDelete: boolean,
	rehabActions: RehabAction[],
): GridColDef[] => [
	{
		field: 'actionId',
		headerName: t('Asset Group Name'),
		sortable: true,
		minWidth: 160,
		flex: 1,
		align: 'left',
		type: 'singleSelect',
		filterOperators: getGridSingleSelectOperators().filter(
			operator => operator.value === 'isAnyOf',
		),
		valueOptions: rehabActions?.map(action => ({
			value: action.actionId,
			label: action.actionId,
		})),
	},
	{
		field: 'notes',
		headerName: t('Description'),
		sortable: true,
		minWidth: 200,
		flex: 1,
		align: 'left',
	},
	{
		field: 'assetCount',
		headerName: t('Asset Count'),
		sortable: true,
		flex: 1,
		align: 'left',
		headerAlign: 'left',
		type: 'number',
		renderCell: params => {
			return <SkeletonCell id={params.id} value={params.value} />;
		},
	},
	{
		field: 'assetCountPercent',
		headerName: t('Asset Count (%)'),
		sortable: true,
		flex: 1,
		align: 'left',
		headerAlign: 'left',
		type: 'number',
		renderCell: params => {
			return <SkeletonCell id={params.id} value={params.value} />;
		},
	},
	{
		field: 'assetLength',
		headerName: t('Length ({{unit}})', { unit: lengthUnit }),
		sortable: true,
		flex: 1,
		align: 'left',
		headerAlign: 'left',
		type: 'number',
		renderCell: params => {
			return <SkeletonCell id={params.id} value={params.value} />;
		},
	},
	{
		field: 'assetLengthPercent',
		headerName: t('Length (%)'),
		sortable: true,
		flex: 1,
		align: 'left',
		headerAlign: 'left',
		type: 'number',
		renderCell: params => {
			return <SkeletonCell id={params.id} value={params.value} />;
		},
	},
	{
		field: 'menu',
		headerName: '',
		sortable: false,
		filterable: false,
		hideable: false,
		maxWidth: 50,
		minWidth: 50,
		width: 50,
		align: 'center',
		disableColumnMenu: true,
		type: 'actions',
		getActions: (params: GridRowParams) => {
			return MenuCell(params, onActionClicked, allowDelete);
		},
	},
];
